import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/suppliers/form'
import { api, actionCreators } from 'store/modules/suppliers'

const metadata = {
  icon: 'truck',
  page: 'suppliers',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
